

































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import MultiSelect from 'vue-multiselect';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import ProjectsData from '@/ts/ProjectsData';
import BuildingData from '@/ts/BuildingData';
import VariantData from '@/ts/VariantData';

@Component({
    components: {
        MultiSelect,
        DatePicker,
    },
    computed: {
        ...mapGetters({
            allCountries: 'Properties/allCountries',
        }),
    },
})
export default class TenantApplicationPanel extends Mixins(InputFieldMethods, LocalizationMethods) {
    public socialTagsSearch: string = '';
    public educationalTagsSearch: string = '';

    constructor() {
        super();
    }

    get selectedProjects(): number[] {
        return this.currentTenantApplication.projects.map((p: any) => p.id);
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    get buildings(): BuildingData[] {
        return !this.selectedProjects.length
            ? this.$store.getters['Buildings/allBuildings']
            : this.$store.getters['Buildings/projectsBuildings'](this.selectedProjects);
    }

    get variants(): VariantData[] {
        return !this.selectedProjects.length
            ? this.$store.getters['Variants/allVariants']
            : this.$store.getters['Variants/projectsVariants'](this.selectedProjects);
    }

    get currentTenant() {
        return this.$store.getters['UserManagement/getCarrentTenantUser'];
    }

    get currentTenantApplication() {
        return this.$store.getters['UserManagement/getCarrentTenantUser'].application;
    }

    get socialTags() {
        return this.$store.getters['Tags/getSocialTags'];
    }

    get educationalTags() {
        return this.$store.getters['Tags/getEducationalTags'];
    }

    get professionTags() {
        return this.$store.getters['Tags/getProfessionTags'];
    }

    get currentTenantApplicationSocialTags() {
        return this.currentTenantApplication.socialClubTags;
    }

    get currentTenantApplicationEducationalTags() {
        return this.currentTenantApplication.educationTags;
    }

    get filteredApplicationEducationalTags() {
        const filteredApplicationEducationalTags = this.educationalTags;
        const existingTagIds = this.currentTenantApplicationEducationalTags.map((t: any) => t.id);
        return filteredApplicationEducationalTags.filter((tag: any) => {
            return !existingTagIds.includes(tag.id) && tag.name.toLowerCase().includes(this.educationalTagsSearch.toLowerCase());
        });
    }

    get filteredApplicationSocialTags() {
        const filteredApplicationSocialTags = this.socialTags;
        const existingTagIds = this.currentTenantApplicationSocialTags.map((t: any) => t.id);
        return filteredApplicationSocialTags.filter((tag: any) => {
            return !existingTagIds.includes(tag.id) && tag.name.toLowerCase().includes(this.socialTagsSearch.toLowerCase());
        });
    }

    get errorCollection() {
        return this.errors.any();
    }

    public removeApplicationEducationalTag(tag: any) {
        this.$store.commit(Mutations.REMOVE_APPLICATION_EDUCATIONAL_TAG, tag.id);
    }

    public removeApplicationSocialClubTag(tag: any) {
        this.$store.commit(Mutations.REMOVE_APPLICATION_SOCIAL_TAG, tag.id);
    }

    public addApplicationEducationalTag(tag: any) {
        this.$store.commit(Mutations.ADD_APPLICATION_EDUCATIONAL_TAG, tag);
    }

    public addApplicationSocialClubTag(tag: any) {
        this.$store.commit(Mutations.ADD_APPLICATION_SOCIAL_TAG, tag);
    }

    public closeDropDown() {
        this.socialTagsSearch      = '';
        this.educationalTagsSearch = '';
    }

    public fetchProfilingVariantsAndBuildings() {
        this.$store.commit(Mutations.RESET_PROFILING_APPLICATION_VARIANTS_AND_BUILDINGS, this.selectedProjects);
    }

    public saveApplicationChanges() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                const currentTenantApplication = this.currentTenantApplication;
                const data = {
                    id: currentTenantApplication.id,
                    name: currentTenantApplication.first_name,
                    lastName: currentTenantApplication.last_name,
                    nationality: currentTenantApplication.nationality,
                    birthday: currentTenantApplication.birthday,
                    email: currentTenantApplication.mail,
                    phoneNumber: currentTenantApplication.phone,
                    gender: currentTenantApplication.gender,
                    profession: currentTenantApplication.professional,
                    education: currentTenantApplication.educationTags.map((t: any) => t.id),
                    socialClubTagIds: currentTenantApplication.socialClubTags.map((t: any) => t.id),
                    projectsIds: currentTenantApplication.projects.map((t: any) => t.id),
                    variantIds: currentTenantApplication.variants.map((t: any) => t.id),
                    buildingIds: currentTenantApplication.buildings.map((t: any) => t.id),
                    resident: currentTenantApplication.resident,
                    about: currentTenantApplication.about_me,
                };

                this.$store.dispatch(Actions.SAVE_APPLICATION_CHANGES, data);
            }
        });
    }

    public created() {
        window.addEventListener('click', this.closeDropDown);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_TAGS, {type: 'demographic'});
        this.$store.dispatch(Actions.FETCH_COUNTRIES);
        this.$store.dispatch(Actions.FETCH_PROJECTS);
        this.$store.dispatch(Actions.FETCH_BUILDINGS);
        this.$store.dispatch(Actions.FETCH_VARIANTS);
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }
}
